import { useSelector, useDispatch } from "react-redux";
import { getTablePendingFields } from "@fas/cpa-state-manager/services/selectors/table";
import { setTablePendingFields } from "@fas/cpa-state-manager/redux/actions/table";
import type { UseTableHook } from "@fas/cpa-state-manager/redux/hooks";
import { useTable } from "@fas/cpa-state-manager/redux/hooks";
import type {
  Filters,
  Sorting,
} from "@fas/cpa-state-manager/redux/actions/table/actions";
import { changeTableSorting } from "@fas/cpa-state-manager/redux/actions/table/actions";
import { useApplyFilters } from "../useTableFilters/useTableFilters";

export type UseConfigureReportHookArgs = {
  tableKey: string;
};
export type UseConfigureReportHook = {
  filters: Filters;
  fields: string[];
  onChangeFilters: (arg0: Filters) => unknown;
  onChangeSorting: (arg0: Sorting) => unknown;
  onChangeFields: (arg0: string[]) => unknown;
  onApply?: () => unknown;
};
export const useConfigureReport: (
  arg0: UseConfigureReportHookArgs,
) => UseConfigureReportHook = ({ tableKey }) => {
  const dispatch = useDispatch();
  const { filters, onChangeFilters }: UseTableHook<any> = useTable(tableKey);
  const fields: string[] = useSelector((state: any): string[] =>
    getTablePendingFields(state, tableKey)
  );

  const onChangeFields: (arg0: string[]) => unknown = (newFields) =>
    dispatch(setTablePendingFields(tableKey, newFields));

  const onChangeSorting: (arg0: Sorting) => unknown = (newSorting) =>
    dispatch(changeTableSorting(tableKey, newSorting));

  const onApply: any = useApplyFilters({
    tableKey,
  });
  return {
    filters,
    fields,
    onChangeFilters,
    onChangeFields,
    onChangeSorting,
    onApply,
  };
};
